/**
* Resume Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Resume Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'resume-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.resume-content' ).each( function( key, val ) {
        const thugHead = $( this ).find( '.fit-image img' )[0];
        const height = $( this ).outerHeight();
        window.scrollRefreshPriority--;

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            end: 'bottom 75%',
            refreshPriority: window.scrollRefreshPriority,
            scrub: 0,
            onEnter: ( x, y, z ) => {
              $( val ).find( '.thug-head' ).addClass( 'is-loaded' );
            },
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'resume-content', COMPONENT );
} )( app );
